import { PHOTOS_URL } from "../../../constants";
import { Button } from "@cocunat/ui-components";

function HomeLaunchingsBanners({ component: Component, ...props }: any) {
  return (
    <div
      className="launchingBannerHome"
      style={{
        backgroundImage: `url(https://resizing.cocunat.com/r/?fit=contain&image=${PHOTOS_URL}${props.img}&quality=95)`,
      }}
    >
      <div className={`inner ${props.textPosition}`}>
        <h1>{props.title}</h1>
        <Button style={{ width: "150px", float: props.textPosition }}>
          {props.buttonText}
        </Button>
      </div>
    </div>
  );
}
export default HomeLaunchingsBanners;
